import React from 'react'
import PropTypes from 'prop-types'
import SocialGithubIcon from '@offerzen/zenicon/SocialGithubIcon'
import SocialLinkedinIcon from '@offerzen/zenicon/SocialLinkedinIcon'
import SocialBitbucketIcon from '@offerzen/zenicon/SocialBitbucketIcon'
import SocialBehanceIcon from '@offerzen/zenicon/SocialBehanceIcon'
import SocialBlogIcon from '@offerzen/zenicon/SocialBlogIcon'
import SocialDribbbleIcon from '@offerzen/zenicon/SocialDribbbleIcon'
import SocialHangoutsIcon from '@offerzen/zenicon/SocialHangoutsIcon'
import SocialRssIcon from '@offerzen/zenicon/SocialRssIcon'
import SocialFacebookIcon from '@offerzen/zenicon/SocialFacebookIcon'
import SocialTwitterIcon from '@offerzen/zenicon/SocialTwitterIcon'
import HyperLinkIcon from '@offerzen/zenicon/HyperlinkIcon'
import WorldIcon from '@offerzen/zenicon/WorldIcon'
import AccessibleIcon from '../../../../elements/AccessibleIcon'
import { colors } from '../../../../themes'

import styles from './styles'

const icons = [
  { name: 'social-github', icon: SocialGithubIcon },
  { name: 'social-linkedin', icon: SocialLinkedinIcon },
  { name: 'social-bitBucket', icon: SocialBitbucketIcon },
  { name: 'social-behance', icon: SocialBehanceIcon },
  { name: 'social-dribbble', icon: SocialDribbbleIcon },
  { name: 'social-blog', icon: SocialBlogIcon },
  { name: 'social-hangouts', icon: SocialHangoutsIcon },
  { name: 'social-rss', icon: SocialRssIcon },
  { name: 'social-facebook', icon: SocialFacebookIcon },
  { name: 'social-twitter', icon: SocialTwitterIcon },
  { name: 'world', icon: WorldIcon },
]
const OnlineProfileItem = ({ url, name: iconName }) => {
  const displayIcon = icons.filter(icon => icon.name === iconName)[0] || { icon: HyperLinkIcon }
  return (
    <li>
      <a href={url} target="_blank" className={styles.button} rel="noreferrer" aria-label={iconName}>
        <AccessibleIcon icon={displayIcon.icon} color={colors.grayChateau} size={18} />
      </a>
    </li>
  )
}

OnlineProfileItem.propTypes = {
  url: PropTypes.string,
  name: PropTypes.string,
}

export default OnlineProfileItem
